/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Pros_4Inputs */

const en_pc_rv_pros_4 = /** @type {(inputs: Pc_Rv_Pros_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast GPU rendering on modest hardware`)
};

const zh_pc_rv_pros_4 = /** @type {(inputs: Pc_Rv_Pros_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`普通配置上也有流畅的 GPU 渲染`)
};

/**
* | output |
* | --- |
* | "Fast GPU rendering on modest hardware" |
*
* @param {Pc_Rv_Pros_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_pros_4 = /** @type {((inputs?: Pc_Rv_Pros_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Pros_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_pros_4(inputs)
	return zh_pc_rv_pros_4(inputs)
});
export { pc_rv_pros_4 as "pc.rv.pros.4" }